document.addEventListener('alpine:init', () => {
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: 1,
      packSize: 1,
      init() {
        // Read pack size from data attribute, default to 1
        this.packSize = parseInt(this.$root.dataset.packSize, 10) || 1;

        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = Math.max(10, this.packSize);
          } else {
            this.quantity = Math.max(parseInt(this.dropdownQuantity, 10), this.packSize);
          }
        } else {
          // Set initial quantity to pack size
          this.quantity = this.packSize;
        }

        // Ensure quantity is a multiple of pack size
        if (this.quantity % this.packSize !== 0) {
          this.quantity = Math.ceil(this.quantity / this.packSize) * this.packSize;
        }
      },
      dispatchInputChange() {
        this.$refs.quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      decreaseQuantity() {
        // Decrease by pack size, but don't go below pack size (minimum)
        if (this.quantity > this.packSize) {
          this.quantity -= this.packSize;
        }
        this.dispatchInputChange();
      },
      increaseQuantity() {
        this.quantity += this.packSize;
        this.dispatchInputChange();
      },
    };
  });
});
